import { readApiError } from '@/services/api';

export const ACCESS_JUSTIFICATION_REQUIRED = 'access_justification_required';

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

const bodyOf = (error: unknown): unknown => (isRecord(error) && 'data' in error ? error.data : undefined);

export function hasJustificationRequiredCode(error: unknown): boolean {
    if (!isRecord(error)) return false;

    return error.code === ACCESS_JUSTIFICATION_REQUIRED || readApiError(bodyOf(error)).code === ACCESS_JUSTIFICATION_REQUIRED;
}

/** True only for a refusal naming this Agreement, so one page never re-prompts for another's. */
export function isJustificationRequired(error: unknown, agreementId: string): boolean {
    const body = bodyOf(error);

    return hasJustificationRequiredCode(error) && isRecord(body) && body.agreement_id === agreementId;
}
